import React from 'react';
import { useSelector } from 'react-redux';
import AssetTypePageLayout from './Layouts/assetTypeDetails';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
import { getUserRoles } from 'reducers/users';

const AssetTypeDetails = props => {
  const userRoles = useSelector(state => getUserRoles(state));
  const loading = useSelector(state => state.ui.loading);
  return (
    <AssetTypePageLayout
      {...props}
      editable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      loading={loading}
    />
  );
};
export default AssetTypeDetails;
